import dayjs from "dayjs";

export const OPENING_DATE = "2026-07-15";
export const GAME_END_DATE = "2026-08-31";
export const FINISH_START_DATE = "2026-09-01";
export const REGULARIZATION_END_DATE = "2026-09-15";

// Mettre à false en production
export const BYPASS_DATE_GUARDS = false;

export function isBeforeOpening(date = dayjs()) {
  return date.isBefore(dayjs(OPENING_DATE).startOf("day"));
}

export function isAfterGameEnd(date = dayjs()) {
  return date.isAfter(dayjs(GAME_END_DATE).endOf("day"));
}

export function isGameOpen(date = dayjs()) {
  return !isBeforeOpening(date) && !isAfterGameEnd(date);
}

export function isFinishAvailable(date = dayjs()) {
  return !date.isBefore(dayjs(FINISH_START_DATE).startOf("day"));
}

export function isRegularizationOpen(date = dayjs()) {
  return !date.isAfter(dayjs(REGULARIZATION_END_DATE).endOf("day"));
}

export function isAfterRegularization(date = dayjs()) {
  return date.isAfter(dayjs(REGULARIZATION_END_DATE).endOf("day"));
}
